module.exports = __webpack_public_path__ + "img/plus.81dd929c.svg";